export default function GemDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 my-14 ${className}`} aria-hidden>
      <span className="h-px w-24 sm:w-40 bg-gradient-to-r from-transparent via-gold/60 to-gold/70" />
      <span className="relative inline-flex">
        <span className="gem-diamond" />
      </span>
      <span className="h-px w-24 sm:w-40 bg-gradient-to-l from-transparent via-gold/60 to-gold/70" />
    </div>
  );
}
